import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { useState } from 'react';
import packageJson from '../../../package.json';
import { loginAction } from '../../actions/loginAction';
import { LoadingSpinnerModal } from '../../components/dab';
import { clearRefreshToken, handleLogout } from "../common/functions";

interface ILoginProps {
	dispatch: Dispatch<any>;
	loginData: any;
	tokenValue: string;
}

const ResetPassword: React.SFC<ILoginProps> = ({ dispatch, loginData, tokenValue }) => {

	const [formSubmit, setformSubmit] = useState(false);
	const [isShowForgetPWD, setIsShowForgetPWD] = useState(false);
	const [isShowForgetPWDSuccess, setIsShowForgetPWDSuccess] = useState(false);
	const [forgetPwdInput, setForgetPwdInput] = useState({
		newPassword: "",
		confirmPassword: "",
		token: tokenValue
	})
	const [error, setError] = useState(false);

	React.useEffect(() => {
		setformSubmit(false);
		setIsShowForgetPWD(false);
		dispatch(loginAction.forgotPasswordCheckToken(tokenValue));
		document.title = "Reset Password - Daily Audio Bible Administration";
	}, []);

	const handlePWDChange = (event: any) => {
		const { name, value } = event.target	
		setForgetPwdInput({ ...forgetPwdInput, [name]: value })
	};

	const handleSubmit = (e: any) => {
		e.preventDefault();		
		setformSubmit(true);
		if (forgetPwdInput.newPassword === forgetPwdInput.confirmPassword) {			
			dispatch(loginAction.forgotPasswordReset(forgetPwdInput));
		} else {
			setError(true)
			setformSubmit(false);
		}
	};	

	if (loginData && loginData.isSuccess) {
		const loggedIn = localStorage.getItem('AUTHDATA');
		if (!isShowForgetPWD && !formSubmit) {
			setIsShowForgetPWD(true);
		}
		if (isShowForgetPWD && formSubmit) {
			setIsShowForgetPWD(false);
			setformSubmit(false);
			setIsShowForgetPWDSuccess(true);
			if (loggedIn) {
				handleLogout(false);
				sessionStorage.clear();
				clearRefreshToken();
				localStorage.setItem('version', packageJson.version);
			}			
		}
	}

	return (
		<div className='login-page' id="login">
			{loginData && loginData.isLoading && (<LoadingSpinnerModal isShowModal={loginData.isLoading} modalChange={() => { }} />)}

			{!isShowForgetPWDSuccess && !loginData.isSuccess && loginData.isError && (
				<div className="alert alert-dismissible alert-danger">{loginData.status}</div>)}

			{isShowForgetPWDSuccess && !loginData.isSuccess && loginData.isError && (
				<div className="alert alert-dismissible alert-danger">{loginData.status}</div>)}

			{isShowForgetPWDSuccess && loginData.isSuccess && !loginData.isError && (
				<div data-testid="passwordResetContainer" className="alert alert-dismissible alert-success">
					<strong>Well done!</strong> Password changed successfully, Click <a href="/login" className="alert-link">Login</a>.
				</div>)}

			{isShowForgetPWD && !isShowForgetPWDSuccess && (
				<form onSubmit={handleSubmit}>
					{error && <div className="alert alert-dismissible alert-danger">The two passwords that you entered do not match!</div>}
					<div className="form-group" data-testid="newPasswordTestId">
						<label htmlFor="password" className="">New Password</label>
						<input name="newPassword" required={true} onChange={handlePWDChange}
							pattern="^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,16}$"
							minLength={6} maxLength={16} id="password" type="password"
							className="is-untouched is-pristine av-invalid form-control" defaultValue="" />
					</div>
					<div className="form-group" data-testid="confirmPasswordTestId">
						<label htmlFor="confirmpassword" className="">Retype New Password</label>
						<input name="confirmPassword" required={true} id="confirmpassword" type="password"
							pattern="^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,16}$"
							minLength={6} maxLength={16} 
							className="is-untouched is-pristine av-invalid form-control" defaultValue=""
							onChange={handlePWDChange} />
					</div>
					<button id="submit" data-testid="submitButtonTestId" className="btn-submit-frm btn btn-secondary">Submit</button>
				</form>
			)}
		</div>
	);
};

const mapStateToProps = (state: any) => {
	const { loginData } = state;
	return {
		loginData
	};
};

export default connect(mapStateToProps)(ResetPassword);
